import { render, staticRenderFns } from "./WhatTodoDialog.vue?vue&type=template&id=35a7f696"
import script from "./WhatTodoDialog.vue?vue&type=script&lang=js"
export * from "./WhatTodoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports